import { usePlayerActorScene } from '@cartwhl/3d/player';

import type { KeyPoseFkJointId } from '../types';
import MotionEditorBoneMeshPicker from './MotionEditorBoneMeshPicker';
import type {
  MotionEditorBonePick,
  MotionEditorBoneSelectHandler,
} from './types';

interface MotionEditorLiveBoneHoverPickerProps {
  actorId: string;
  enabled: boolean;
  hoveredJointIds?: readonly KeyPoseFkJointId[];
  onBoneHover?: (pick: MotionEditorBonePick | null) => void;
  onBoneSelect?: MotionEditorBoneSelectHandler;
  raycastEnabled?: boolean;
  selectedJointIds?: readonly KeyPoseFkJointId[];
}

export default function MotionEditorLiveBoneHoverPicker({
  actorId,
  enabled,
  hoveredJointIds,
  onBoneHover,
  onBoneSelect,
  raycastEnabled,
  selectedJointIds,
}: MotionEditorLiveBoneHoverPickerProps) {
  const actorScene = usePlayerActorScene(actorId);

  if (!enabled) return null;

  return (
    <MotionEditorBoneMeshPicker
      scene={actorScene}
      hoveredJointIds={hoveredJointIds}
      onBoneHover={onBoneHover}
      onBoneSelect={onBoneSelect}
      raycastEnabled={raycastEnabled}
      selectedJointIds={selectedJointIds}
    />
  );
}
